/**
  * теперь этот файл/поток будет кодироваться в UTF-8
*/
import './stores/contragentStore';
// components include after module
import './components/cart_contragent_selector/script';
